module.exports = __webpack_public_path__ + "static/demonstration-eeaf06f1f8177fa3cf52e8ed5fb73ac4.jpg";